import { Box, customStyled } from '@mafc/trolly';

export const StyledDrawerTitle = customStyled(Box)`
  font-family: ${props => props.theme.fonts.montserrat};
  font-size: ${props => props.theme.fontSizes[3]};
  font-weight: ${props => props.theme.fontWeights[8]};
  color: ${props => props.theme.colors.black};
  text-align: center;
  margin-top: ${props => props.theme.space[3]}px;
  @media (min-width: ${props => props.theme.breakpoints[1]}) {
    font-size: ${props => props.theme.fontSizes[6]};
    margin-top: 0;
    width: 100%;
    text-align: left;
  }
`;
